import { Component, Inject, OnInit, OnDestroy } from "@angular/core";

import { Store } from "@src/store";
import { DialogManagerService } from "@src/services";
import { userActions } from "@src/store/reducers/userReducer";
import { cmsActions } from "@src/store/reducers/cmsReducer";

import * as _ from "lodash";
import $ from "jquery";
import { UserGitServerCredentials } from "./user-git-server/user-git-server.component";

@Component({
  selector: "users",
  template: require('./users.component.html'),
  styles: [require('./users.component.scss')],
})
export class UsersComponent implements OnInit, OnDestroy {
  public users: any[];
  public listMenu: any;
  public user: any;

  private unSubscribe: any;
  private unsubscribe: any;
  private unSubscribeCms: any;
  private unSubscribers: any;
  private indexInList: any;
  public AuthType: string;
  public isSyncEnabled: boolean = false;

  constructor(
    private store: Store,
    @Inject("$state") private $state: any,
    private dialogManagerService: DialogManagerService
  ) {}

  public async ngOnInit() {
    this.AuthType = JSON.parse(localStorage.getItem("AuthType"));
    this.isGlobalAdmin();
    this.unSubscribe = this.store.subscribe(() => {
      this.store.dispatch({ type: userActions.GET_USERS }).then((x) => {
        if (x) {
        }
        const usersState = this.store.getState().user.users;
        if (usersState) {
          this.users = usersState;
          this.unSubscribe();
        }
      });
    });
    this.unSubscribeCms = this.store.subscribe(() => {
      const cmsState = this.store.getState().cmss;
      if (cmsState && cmsState.cmss && cmsState.cmss.length > 0) {
        this.unSubscribeCms();
      }
    });
    this.store.dispatch({ type: cmsActions.GET_ALL_CMS });
    this.store
      .dispatch({ type: userActions.IS_SYNC_ENABLED })
      .then((isSync) => {
        this.isSyncEnabled = isSync;
      });
  }

  public ngOnDestroy() {
    if (this.unSubscribers) {
      this.unSubscribers.forEach((x: any) => x());
    }
  }

  public canAddUser() {
    return (
      !this.isSyncEnabled &&
      (!(this.AuthType == "oidc") || localStorage.getItem("AuthOnly") == "true")
    );
  }
  private isGlobalAdmin() {
    this.unsubscribe = this.store.subscribe(() => {
      const user = this.store.getState().user;
      if (user && user.checkingPermissions) {
        this.isGlobalAdmin = user.checkingPermissions.find(
          (x: any) => x.key === "Admin" && x.value === true
        );
        if (!this.isGlobalAdmin) {
          const usersGroupRoute =
            "app.authorized.usersRolesManagement.usersManagement.usersGroups";
          if (this.$state.current.name !== usersGroupRoute) {
            this.$state.go(usersGroupRoute);
          }
        } else {
          this.listMenu = this.$state.params.listMenu;
        }
        this.unsubscribe();
      }
    });
  }

  public getUser(selectedUser: any, indexInList: any) {
    this.indexInList = indexInList;
    if (selectedUser.isNew && !selectedUser.id) {
      this.user = selectedUser;
      // for change -1 to new id
      this.unSubscribe = this.store.subscribe(() => {
        if (this.store.getState().user.user) {
          if (selectedUser.id === -1 && this.user) {
            selectedUser.id = this.user.id;
            selectedUser.status = this.user.status;
            selectedUser.domains = this.user.domains;
            selectedUser.isNew = false;
            setTimeout(() => {
              $("ul.dbm-list > li:first-child").click();
            }, 50);
            this.unSubscribe();
          }
        }
      });

      this.addDummyUserGitCredentialsIfNone();

      return;
    }
    this.unSubscribers = [
      this.store.subscribe(() => {
        const userState = this.store.getState().user.user;
        if (userState) {
          this.user = userState;
          if (
            selectedUser.id === this.user.id &&
            selectedUser.status !== this.user.status
          ) {
            selectedUser.status = this.user.status;
          }

          this.addDummyUserGitCredentialsIfNone();
        }
      }),
    ];
    if (selectedUser.id !== -1) {
      this.store.dispatch({
        type: userActions.GET_USER,
        payload: { userId: selectedUser.id },
      });
    }
  }

  //If there are no git credentials, add dummy one
  private addDummyUserGitCredentialsIfNone() {
    //add git server if there are none
    try {
      if (this.user && this.user.name != null)
        if (
          this.user.gitRepositoryServerCredentials == null ||
          this.user.gitRepositoryServerCredentials?.length == 0
        ) {
          this.user.gitRepositoryServerCredentials =
            new Array<UserGitServerCredentials>();
          this.user.gitRepositoryServerCredentials.push(
            new UserGitServerCredentials(this.user.id, 1, "", "")
          );
        }
    } catch (e) {
      console.log(e);
    }
  }

  public addUser() {
    this.user = { name: "New User", isNew: true, status: true };
    this.users = [this.user, ...this.users];
    this.indexInList = 0;
    this.getUser(this.user, 0);
    setTimeout(() => {
      $("ul.dbm-list > li:first-child").click();
    }, 50);
  }

  public resetPassword() {
    this.store.dispatch({
      type: userActions.RESET_PASSWORD,
      payload: { userId: this.user.id },
    });
  }

  public duplicate() {
    this.unSubscribe = this.store.subscribe(() => {
      const usersState = this.store.getState().user.users;
      if (usersState) {
        if (this.users.length < usersState.length) {
          this.users = usersState;
          this.users = _.orderBy(this.users, ["name"], ["asc"]);
          this.user = this.store.getState().user.user;
          this.unSubscribe();
        }
      }
    });
    this.store.dispatch({
      type: userActions.DUPLICATE_USER,
      payload: { userId: this.user.id },
    });
  }

  public setStatus() {
    this.store.dispatch({
      type: userActions.SET_USER_STATUS,
      payload: { userId: this.user.id, status: !this.user.status },
    });
  }

  public delete() {
    const onConfirm = () => {
      if (this.user.isNew) {
        if (this.indexInList >= 0) {
          this.users = [
            ...this.users.slice(0, this.indexInList),
            ...this.users.slice(this.indexInList + 1),
          ];
          this.user = this.users ? this.users[0] : null;
        }
        return;
      }
      this.unSubscribe = this.store.subscribe(() => {
        const usersState = this.store.getState().user.users;
        if (usersState) {
          if (this.users.length > usersState.length) {
            this.users = usersState;
            this.users = _.orderBy(this.users, ["name"], ["asc"]);
            this.user = this.store.getState().user.user;
            this.unSubscribe();
          }
        }
      });
      this.store.dispatch({
        type: userActions.DELETE_USER,
        payload: { userId: this.user.id },
      });
    };
    const dialogData = {
      title: "Delete User",
      action: "delete",
      objectType: "user",
      item: this.user.name,
    };
    this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/users.component.ts